import type { UserRole } from '../types';

export const ROLE_LABELS: Record<UserRole, string> = {
  admin: 'Admin',
  board_member: 'Conseil syndical',
  reader: 'Lecteur',
};

// Only admins can write (RLS); board members and readers consult the space.
export const ROLE_DESCRIPTIONS: Record<UserRole, string> = {
  admin: 'Gère tout l\'espace : sujets, prestataires, documents, réunions, membres et paramètres.',
  board_member: 'Consulte tout l\'espace en tant que membre du conseil syndical, sans pouvoir le modifier.',
  reader: 'Consulte l\'espace sans pouvoir le modifier, hors boîte de réception et notes privées, par exemple un copropriétaire.',
};

export const ROLE_OPTIONS: UserRole[] = ['admin', 'board_member', 'reader'];
